const { defineMessages } = require('@sm/intl');

const TYPE_TEXT = '[Type: Text][Vis: high] - Feature Set Category Name';

export default defineMessages({
  TEAM_COLLABORATION: {
    id: 'PricingDetails.FeatureCell.TeamCollaboration',
    defaultMessage: 'Team Collaboration',
    desc: TYPE_TEXT,
  },
  TEAM_MANAGMENT: {
    id: 'PricingDetails.FeatureCell.TeamManagement',
    defaultMessage: 'Team Management',
    desc: TYPE_TEXT,
  },
  ENTERPRISE_GRADE_SECURITY: {
    id: 'PricingDetails.FeatureCell.EnterpriseGradeSecurity',
    defaultMessage: 'Enterprise-grade admin and security',
    desc: TYPE_TEXT,
  },
  SURVEY_CAPABILITIES: {
    id: 'PricingDetails.FeatureCell.SurveyCapabilities',
    defaultMessage: 'Survey Capabilities',
    desc: TYPE_TEXT,
  },
  FAST_SUPPORT: {
    id: 'PricingDetails.FeatureCell.FastSupport',
    defaultMessage: 'Fast Support',
    desc: TYPE_TEXT,
  },
  SURVEY_BUILDER: {
    id: 'PricingDetails.FeatureCell.SurveyBuilder',
    defaultMessage: 'Survey Builder',
    desc: TYPE_TEXT,
  },
  CUSTOMIZATION_BRANDING: {
    id: 'PricingDetails.FeatureCell.CustomizationBranding',
    defaultMessage: 'Customization & Branding',
    desc: TYPE_TEXT,
  },
  ANALYSIS_REPORTING: {
    id: 'PricingDetails.FeatureCell.AnalysisReporting',
    defaultMessage: 'Analysis & Reporting',
    desc: TYPE_TEXT,
  },
  RESPONSE_MANAGEMENT: {
    id: 'PricingDetails.FeatureCell.ResponseManagement',
    defaultMessage: 'Response Management',
    desc: TYPE_TEXT,
  },
  ENHANCED_SECURITY: {
    id: 'PricingDetails.FeatureCell.EnhancedSecurity',
    defaultMessage: 'Enhanced Security',
    desc: TYPE_TEXT,
  },
  PARTNER_INTEGRATIONS: {
    id: 'PricingDetails.FeatureCell.PartnerIntegrations',
    defaultMessage: 'Partner Integrations & APIs',
    desc: TYPE_TEXT,
  },
});
